<script setup lang="ts">
  import { SelectInput, DatePicker, IconImage } from '@/shared/ui';
  import CalendarIcon from '@/shared/assets/icons/CalendarIcon.svg';
  import type {
    UserPositionDateState,
    UserPositionDateActions,
    UserPositionDateHelpers,
  } from './types/session.types';

  const props = withDefaults(
    defineProps<{
      label: string;
      dateLabel?: string;
      state: UserPositionDateState;
      actions: UserPositionDateActions;
      helpers: UserPositionDateHelpers;
    }>(),
    {
      dateLabel: 'Data',
    }
  );
</script>

<template>
  <div class="flex flex-col gap-3 p-6">
    <h3 class="text-sm font-semibold text-gray-07">
      {{ label }}
    </h3>
    <div class="grid grid-cols-3 gap-4">
      <div class="flex flex-col gap-2">
        <span class="text-sm font-medium text-gray-07">Colaborador Responsável</span>
        <SelectInput
          :model-value="state.memberId"
          :options="helpers.userOptions"
          label="Selecione o colaborador"
          @update:model-value="actions.setMemberId"
        />
      </div>
      <div class="flex flex-col gap-2">
        <span class="text-sm font-medium text-gray-07">Cargo</span>
        <SelectInput
          :model-value="state.positionId"
          :options="helpers.getUserPositions(state.memberId)"
          label="Selecione o cargo"
          @update:model-value="actions.setPositionId"
        />
      </div>
      <div class="flex flex-col gap-2">
        <span class="text-sm font-medium text-gray-07">{{ props.dateLabel }}</span>
        <button
          type="button"
          class="flex items-center gap-2 bg-white-01 px-4 py-2.5 border border-gray-02 rounded-lg text-gray-07 text-sm focus:outline-none focus:border-gray-07"
          @click="actions.setDatePickerOpen(true)"
        >
          <IconImage
            :src="CalendarIcon"
            alt="Calendário"
            class="h-4 w-4"
          />
          {{ helpers.formatDate(state.dateString) }}
        </button>
        <DatePicker
          :selected-date="state.date"
          :is-open="state.datePickerOpen"
          @update:selected-date="actions.setDate"
          @update:is-open="actions.setDatePickerOpen"
        />
      </div>
    </div>
  </div>
</template>
